import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';

const ProfileImageWrapper = styled.div`
  grid-column: 1/-1;
  justify-self: center;
  width: 80px;
  height: 80px;
  background: #fbfbfb;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
  .feather-loader {
    animation: spin 1s linear infinite;
  }

  .MuiSnackbar-anchorOriginBottomRight {
    bottom: 50px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 1/2;
    grid-row: auto/span 2;
    justify-self: baseline;
    width: 92px;
    height: 92px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 1/2;
    width: 96px;
    height: 96px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    grid-column: 1/2;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    grid-column: 1/3;
    width: 100px;
    height: 100px;
  }
`;

const ProfileImage = (props) => {
  const { children } = props;

  return (
    <ProfileImageWrapper className="profileImageWrapper">
      {children}
    </ProfileImageWrapper>
  );
};

ProfileImage.propTypes = {
  children: propTypes.node.isRequired,
};

export default ProfileImage;
